import BackendClient from '../../backend-client';
import Request, { modelFactory } from './model';
import { formatFilter } from '../filters';

export default class RequestClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  /* async create(element, type, data) {
    try {
      const response = await this.request('post', 'create')({
        element,
        type,
        data,
      }, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      });

      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  } */

  list = async (start, size, filters = {}, sortparam, asc) => {
    const sort = `${sortparam} ${asc === true ? 'asc' : 'desc'}`;
    const response = await this.request('get', 'listRequest')({
      filters,
      start,
      size,
      sort,
    });

    return this.format(response);
  }

  listApprovals = async (start, size, filters = {}) => {
    const response = await this.request('get', 'approvals')({
      filters,
      start,
      size,
    });
    console.log(this.format(response));
    return this.format(response);
  }

  detail = (type, idTicket, user, filters = {}, isUserTic = false) => {
    const filtersF = formatFilter(filters);
    const userFilter = { $or: [{ customer: `U'${user}'` }, { requestedBy: `U'${user}'` }] };
    const sendFilters = {
      type,
      id: idTicket,
    };
    filtersF.$and.push(userFilter);
    if (isUserTic) {
      filtersF.typeUser = isUserTic;
    }
    // filtersF.$and.push(sendFilters);
    return this.req(JSON.stringify(filtersF), { resourceName: 'detailTicket', ...sendFilters });
  }

  listPend = async (start, size, filters = {}) => {
    const response = await this.request('get', 'list-pend')({
      start, size, filters,
    });

    return this.format(response);
  }
}

export {
  Request,
};
